"use client";

// SBL benefits band — shared Embla autoplay carousel (Figma 8184:57503).

import { Cash, Emoji, LotOfCash } from "iconoir-react";
import type { ComponentType, SVGProps } from "react";

import { ScrollDrivenHorizontalCarousel } from "@/components/blocks/scroll-driven-horizontal-carousel";
import { cn } from "@/lib/utils";

import { BenefitGuaranteeIcon } from "./benefit-guarantee-icon";

interface BenefitCard {
  title: string;
  description: string;
  variant?: "dark" | "light";
}

interface BenefitsGridProps {
  title: string;
  cards: BenefitCard[];
  className?: string;
}

const LIGHT_CARD_ICONS = [LotOfCash, Emoji, Cash] as const;

function LightIcon({ Icon }: { Icon: ComponentType<SVGProps<SVGSVGElement>> }) {
  return (
    <Icon className="text-grey-950 size-6" strokeWidth={1.5} aria-hidden />
  );
}

export function BenefitsGrid({ title, cards, className }: BenefitsGridProps) {
  return (
    <ScrollDrivenHorizontalCarousel
      className={cn(className)}
      title={title}
      dataTestId="small-business-loans-benefits-section"
      cards={cards.map((card, index) => {
        const isLead = index === 0;
        const Light = LIGHT_CARD_ICONS[Math.max(0, index - 1)] ?? Cash;

        return {
          title: card.title,
          description: card.description,
          renderIcon: (isActive) => {
            if (isLead && isActive) {
              return <BenefitGuaranteeIcon className="size-6" />;
            }
            return <LightIcon Icon={isLead ? LotOfCash : Light} />;
          },
        };
      })}
    />
  );
}
